import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_CONFIG_SYS_TMTG,
  SHOW_FORM_TRA_GOP,
  POST_TRA_GOP1,
  CHECK_EDIT_CUSTOMER_TG,
  CHECK_EDIT_TRA_GOP,
  GET_TAI_SAN_THEO_CHO_VAY_TMTG,
} from "actions/ThemMoiBanHangTraGop/actionTypes";
import {
  postTraGopFailure,
  postTraGopSuccess,
  checkEditChoVay as a_checkEditChoVay,
  setEnableEditChoVay,
  setEnableEditCustomer,
  getTaiSanTheoChoVayTMTG as a_getTaiSanTheoChoVayTMTG,
  getConfigSysTMTG,
  setTaiSanTraGop,
} from "actions/ThemMoiBanHangTraGop";
import { pushNotification } from "utils/notifications";
import { setConfig } from "actions/ThemMoiBanHangTraGop";
import CauHinhApi from "service/cauHinhApi";
import { getListPhiKhac, getListPhiKhacTheoChoVay } from "actions/PhiKhac";
import {
  getListPhiKhacHangKy,
  getListPhiKhacHangKyTheoChoVay,
} from "actions/PhiKhacHangKy";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
import CamDoApi from "service/camDoApi";
import CustomerApi from "service/customerApi";
import TaiSanApi from "service/taiSanApi";
import BanHangTraGopApi from "../service/banHangTraGopApi";

function* showFormTraGop(action) {
  try {
    yield put(getComboNguonKhachHang());
    let chovay = action.payload;
    if (chovay && chovay.ChoVayId) {
      yield put(a_checkEditChoVay(chovay.ChoVayId));
      yield put(
        getListPhiKhacTheoChoVay({
          chovayId: chovay.ChoVayId,
          typeChoVay: chovay.Type,
        })
      );
      yield put(
        getListPhiKhacHangKyTheoChoVay({
          chovayId: chovay.ChoVayId,
          typeChoVay: chovay.Type,
        })
      );
      yield put(a_getTaiSanTheoChoVayTMTG({ chovayId: chovay.ChoVayId }));
    } else {
      yield put(getListPhiKhac({ type: 2 }));
      yield put(getListPhiKhacHangKy({ type: 2 }));
      yield put(setTaiSanTraGop({}));
    }
    yield put(getConfigSysTMTG());
  } catch (error) {}
}
function* getTaiSanTheoChoVayTMTG(action) {
  try {
    const response = yield call(TaiSanApi.taiSanTheoChoVay, action.dataSearch);
    if (response.ok && response.data) {
      let lstCamDo = response.data;
      if (lstCamDo.length > 0) {
        yield put(setTaiSanTraGop(lstCamDo[0]));
      }
    } else {
      pushNotification(
        "Không tải được thông tin tài sản cầm cố.",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error) {
    pushNotification(
      "Không tải được thông tin tài sản cầm cố.",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}
function* getConfigSysThemMoiTraGop(action) {
  try {
    const response = yield call(
      CauHinhApi.getConfigSys_TraGop,
      action.dataSearch
    );
    if (response.ok && response.data) {
      yield put(setConfig(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* postTraGop(action) {
  try {
    const response = yield call(BanHangTraGopApi.addAndEdit, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postTraGopFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(postTraGopSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(postTraGopFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(postTraGopFailure());
  }
}

function* checkEditChoVay(action) {
  try {
    const response = yield call(CamDoApi.checkEditChoVay, action.choVayId);
    if (response.ok) {
      yield put(setEnableEditChoVay(response.data));
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
function* checkEditCustomer(action) {
  try {
    const response = yield call(
      CustomerApi.checkEditCustomer,
      action.customerId
    );
    if (response.ok) {
      yield put(setEnableEditCustomer(response.data));
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
function* watchGetRequest() {
  yield takeLatest(GET_CONFIG_SYS_TMTG, getConfigSysThemMoiTraGop);
  yield takeLatest(SHOW_FORM_TRA_GOP, showFormTraGop);
  yield takeLatest(POST_TRA_GOP1, postTraGop);
  yield takeLatest(CHECK_EDIT_TRA_GOP, checkEditChoVay);
  yield takeLatest(CHECK_EDIT_CUSTOMER_TG, checkEditCustomer);
  yield takeLatest(GET_TAI_SAN_THEO_CHO_VAY_TMTG, getTaiSanTheoChoVayTMTG);
  //GET_TAI_SAN_THEO_CHO_VAY_TMTG
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
